import { connect } from 'react-redux'
import { sendSupportMessage } from 'actions'
import Assistance from 'page/Pages/Assistance'

const mapDispatchToProps = (dispatch: Function) => ({
  sendSupportMessage: (value: string) => dispatch(sendSupportMessage(value)),
})

export default connect(null, mapDispatchToProps)(Assistance)
